import { bootstrapApplication } from '@angular/platform-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { migrateLegacyStorageKeys } from 'app/core/storage/legacy-storage-migration';
import { capturePendingMcpAuthorizeFromUrl } from 'app/core/utils/mcp-authorize.util';

// Rename legacy itech_* localStorage keys before anything reads them.
migrateLegacyStorageKeys();

// Capture the MCP OAuth handoff params BEFORE MSAL's redirect bridge (below) strips the query
// string via history.replaceState — otherwise the sign-in page never sees them.
capturePendingMcpAuthorizeFromUrl();

function bootstrap() {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}

// Only run MSAL's redirect bridge on the configured redirectUri (/auth/sign-in).
// Running it on every page strips query params via history.replaceState.
if (window.location.pathname === '/auth/sign-in') {
  broadcastResponseToMainFrame()
    .then(() => {
      // Auth response was broadcast to the parent window — this is a popup, do nothing
    })
    .catch(() => bootstrap());
} else {
  bootstrap();
}
